import React from 'react'
import { SPACING } from '@fedsim/constants'
import { Stack } from '@mui/material'

import { HeaderTertiary } from '../../typography'
import { ImageBlock } from '../../image-block'

const minWidth = 200

export const GenericItem = props => {
  const {
    children = null,
    color = '',
    backgroundColor = '',
    name = '',
    image = ''
  } = props
  return (
    <>
      <Stack direction='row' sx={{ color, minWidth }} spacing={SPACING}>
        <ImageBlock image={image} backgroundColor={backgroundColor} />
        <Stack direction='column' spacing={SPACING}>
          <HeaderTertiary>{name}</HeaderTertiary>
        </Stack>
      </Stack>
      {children}
    </>
  )
}
